import PopupActions from '../../../actions/PopupActions';
import PosCartActions from '../../../actions/PosCartActions';
import NotificationActions from '../../../actions/NotificationActions';
import PosCartStore from '../../../stores/PosCartStore';
import AjaxPromises from '../../../utils/AjaxPromises';
import UserStore from '../../../stores/UserStore';
import { endPoints as CartEndpoints } from '../../../constants/PosCartConstants';

class SpringBigAppliedReward extends React.Component {

    constructor(props) {
        super(props);
        this.removeReward = this.removeReward.bind(this);
    }

    removeReward() {
       
        AjaxPromises.POST(CartEndpoints.REMOVE_SPRINGBIG_REDEMPTION, UserStore.getApiData({
            ShipmentId: this.props.reward.ShipmentId,
            LoyaltyDiscountRedemptionId: this.props.reward.LoyaltyDiscountRedemptionId
        })).then(resp => {
            if(!resp.Result) {
                NotificationActions.error(`Error Applying Reward: ${resp.Message}`);
            }

            PosCartActions.loadUserCart(this.props.guest.Guest_id, this.props.guest.ShipmentId);
            this.props.onRemove();
        });
    }

    render() {
        return (
            <div className='row applied-row'>
                <div className='col-md-6'> <h5>{this.props.reward.DiscountReason}</h5></div>
                <div className='col-md-4'>{this.props.reward.LoyaltyPointCost} points</div>
                <div className='col-md-2'> <i className='fa fa-times click' onClick={this.removeReward}></i> </div>
            </div>
        );
    }
}

export default SpringBigAppliedReward;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/springbig-redeem/SpringBigAppliedReward.jsx